import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import classNames from 'classnames';

import BasicDataPod from '../BasicDataPod';
import Value from '../BasicDataPod/Value';
import './styles.css';

export default function ListDataPod({ content, className, containerClassName, ...rest }) {
  const { list, info, subText, value, boldLastItem } = content;

  return Array.isArray(list) ? (
    <BasicDataPod {...rest} className={containerClassName}>
      <div className={value ? 'list-data-pod-container' : ''}>
        {value && (
          <React.Fragment>
            <Value value={value} className="no-margin simple-text" />
            {subText && <p className="list-pod-subtext">{subText}</p>}
          </React.Fragment>
        )}
        <ul
          className={classNames(
            'list-data-pod-list-container',
            info ? '' : 'no-margin',
            className,
          )}
        >
          {list.map((i, idx) => (
            <li key={idx} className="list-data-pod-li">
              {isString(i) ? (
                <div
                  className={classNames(
                    'list-data-pod-li-single',
                    boldLastItem ? 'bold-last-only' : '',
                  )}
                >
                  {i}
                </div>
              ) : (
                <>
                  <div className="list-data-pod-li-single list-data-pod-li-single-spacing">
                    {i.text}
                  </div>
                  <span className="list-data-pod-li-subtext">{i.subtext}</span>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
      {info ? <p className="list-data-pod-li-info">{info}</p> : null}
    </BasicDataPod>
  ) : null;
}

ListDataPod.propTypes = {
  header: PropTypes.string,
  tooltip: PropTypes.string,
  footer: PropTypes.string,
  content: PropTypes.shape({
    list: PropTypes.array,
    info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.string,
    boldLastItem: PropTypes.bool,
    subText: PropTypes.string,
  }),
  className: PropTypes.string,
};
